// determine which environment we're operating in, based on the document.location

const landingDomains = {
  staging: ['staging.movablecamera.com', 'og-page-maker-staging.herokuapp.com'],
  production: ['www.movablecamera.com', 'share.movablecamera.com']
};

const assetDomains = {
  staging: 'assets-staging.movableink-templates.com',
  production: 'assets.movableink-templates.com'
};

const host = document.location.hostname;

let environment;
if (host.match(assetDomains.production) || landingDomains.production.includes(host)) {
  environment = 'production';
} else if (host.match(assetDomains.staging) || landingDomains.staging.includes(host)) {
  environment = 'staging';
} else {
  environment = 'development';
}

export function landingPage() {
  const { pathname, search } = window.location;
  const hostnames = landingDomains[environment] || ['localhost:4200'];
  const hostname = hostnames[0];

  return ['https://', hostname, pathname, search].join('');
}

export default environment;
